/**
 * quarantine-configuration-request.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class QuarantineConfigurationRequest extends ReplyVerifyingMessage
{
    public tag : MessageTag = MessageTag.REQ_CFG_QUARANTINE;
	public static tag : MessageTag = MessageTag.REQ_CFG_QUARANTINE;

    constructor (public lock : boolean, public minutes : number)
    {
        super();
    }

    public verifyReply (reply : Message) : boolean
    {
        return Message.isA(reply, MessageTag.RSP_CFG_QUARANTINE);
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/admin/quarantine-configuration-request.ts